import React from 'react';
import { Row, Col } from 'react-bootstrap';

const InfoCardsSection = () => {
  const cards = [
    {
      title: "Якщо вже скоро до школи?",
      content: "Дізнатись яка саме школа закріплена за місцем реєстрації дитини можна на освітній карті Києва",
      link: "Перейти до карти шкіл",
      href: "#"
    },
    {
      title: "Відеоінструкція",
      content: "Дізнатись яка саме школа закріплена за місцем реєстрації дитини можна на освітній карті Києва",
      link: "Переглянути на YouTube",
      href: "https://youtu.be/ihuCrfeR170"
    },
    {
      title: "Гроші ходять за дитиною",
      content: "Сучасний підхід у фінансуванні освіти, який забезпечує можливість батькам вибирати заклади дошкільної освіти для своїх дітей",
      link: "Детальніше про програму",
      href: "#"
    },
    {
      title: "Технічна підтримка",
      content: "Отримайте відповідь на свої питання від кваліфікованого спеціаліста",
      link: "Звернутись до підтримки",
      href: "#"
    }
  ];

  return (
    <section className="my-5 info-cards-section">
      
        {cards.map((card, index) => (
            <Row>
                <Col md={12} lg={12} key={index} className="mb-12">
                    <div className="info-card h-100">
                    <div className="card-content">
                        <h5>{card.title}</h5>
                        <p>{card.content}</p>
                    </div>
                    <a href={card.href} className="info-card-link">{card.link}</a>
                    </div>
                </Col>
          </Row>
        ))}
    </section>
  );
};

export default InfoCardsSection;